<template>
  <div class="row section-content row my-4" v-if="this.projects">
    <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3 mb-3"
         v-for="project in this.projects" :key="project.id">
      <div class="card d-flex h-100"
           :title="project.name + ' citizen science project'"
           @click="(evt) => {onCardClick(evt, project);}">
        <img class="card-img-top"
             :src="getImage(project)"
             alt="Logo/Banner">
        <div class="card-body">
          <h4 class="card-title">{{ project.name }}</h4>
          <div class="card-hover-area position-relative">
            <div class="b-card-text default-card-view mb-0">
              {{ ellipsize(project.description, 100) }}
            </div>
            <div class="b-card-text hover-card-view mb-3 position-absolute w-100">
              {{ ellipsize(project.description, 200) }}
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="b-card-text m-0 p-0">
            <div class="row mb-1">
              <div class="col-6">
                <span>
                  <i class="fa fa-ruler-vertical"></i> {{ addThousandsPoint(project.measurementsTotal) }}
                </span>
              </div>
              <div class="col-6 text-align-end">
                <span class="date">
                  <i class="fas fa-calendar-plus"></i> {{ displayDate(project.createdAt) }}
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <b-img :src="'/assets/images/' + (project.approveContacts ? 'closed' : 'open') + '-access.png'"
                       width="34"
                       height="34"
                       :alt="(project.approveContacts ? 'Closed Membership - approval required' : 'Open Membership - no approval required')"
                       :title="(project.approveContacts ? 'Closed Membership - approval required' : 'Open Membership - no approval required')"/>
              </div>
              <div class="col-2">
                <b-img :src="'/assets/images/' + (project.isPrivate ? 'private' : 'public') + '.png'"
                       width="34"
                       height="34"
                       :alt="'Project Data is ' + (project.isPrivate ? 'Private (visible only to members)' : 'Public (visible to all users)')"
                       :title="'Project Data is ' + (project.isPrivate ? 'Private (visible only to members)' : 'Public (visible to all users)')"/>
              </div>
              <div class="col-8">
                <ProjectJoinButton :project="project"></ProjectJoinButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectJoinButton from "../../assets/scripts/project/projectJoinButton";
import DateTime from "../common/date-time/DateTime.vue";

export default {
  components: {
    ProjectJoinButton,
    DateTime,
  },
  props:
    {
      projects: {
        type: Array,
        required: true,
      }
    },
  data() {
    return {};
  },
  methods: {
    getProjectLogo(project) {
      if (project && project.picture && project.picture.path)
        return `url(${project.picture.path})`;
      else
        return "url(https://www.coastkeeper.org/wp-content/uploads/2022/09/Logo-Placeholder-TTC.png)";
    },
    getImage(project) {
      // let imgPath = (project.picture && project.picture.path ? project.picture.path : project.bannerPicture && project.bannerPicture.path ? project.bannerPicture : '/assets/images/generic_img.png')
      let imgPath = project.picture ? project.picture.path : project.bannerPicture ? project.bannerPicture.path : '/assets/images/generic_img.png'
      return imgPath
    },
    addThousandsPoint(number) {
      // Fixes browser debugger error when number is undefined
      if (number == null) number = 0;

      number = number.toString();
      while (true) {
        const n2 = number.replace(/(\d)(\d{3})($|,|\.)/g, "$1,$2$3");
        if (number === n2) break;
        number = n2;
      }
      return number;
    },
    onCardClick(evt, projectData) {
      evt.preventDefault();

      if (evt.target.getAttribute("class").indexOf("btn-join") !== -1) {
        if (JSON.parse(localStorage.getItem("sessionData")) == null) {
          this.$root.$emit("bv::show::modal", "not-logged-in-modal");
          return;
        } else {
          this.joinToProject({id: projectData.id});
          return;
        }
      }

      this.$router.push("/projects/" + projectData.urlField);
    },
  },
};
</script>

<!-- TODO: Migrate any Home specific styles here. -->
<style lang="scss" scoped>

.card-img-top {
  height: 200px;
  object-fit: scale-down;
  object-position: center;
  cursor: pointer;
}

.card-footer {
  max-height: 80px;
  background-color: white;
}

.card-hover-area {
  cursor: pointer;
  .default-card-view,
  .hover-card-view {
    transition: opacity 0.3s ease-in-out;
  }

  .default-card-view {
    opacity: 1;
  }

  .hover-card-view {
    top: 0;
    left: 0;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    margin-top: 0;
  }

  &:hover {
    .default-card-view {
      opacity: 0;
      visibility: hidden;
    }

    .hover-card-view {
      opacity: 1;
      margin-top: -35px;
      visibility: visible;
    }
  }
}

.card:has(.card-hover-area:hover) {
  .card-title,
  .card-header {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease-in-out;
  }
}
</style>
